import { Injectable, inject } from '@angular/core';
import { PartialSuccessResponse, SetStorageType } from 'mbs-ui-shared@models/StorageAccount';
import { StorageAccountsService } from 'mbs-ui-shared@services/storage-accounts/storage-accounts.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { StorageDestinationsFacade } from './storage-destinations.facade';

// Account mutations change the destinations list too: the wizard creates a destination along with the account,
// deletion and its cancellation carry every destination of the account with them
@Injectable({ providedIn: 'root' })
export class StorageAccountsFacade {
  private service = inject(StorageAccountsService);
  private destinationsFacade = inject(StorageDestinationsFacade);

  public create(id: string, data: SetStorageType): Observable<PartialSuccessResponse | null> {
    return this.service.create(id, data).pipe(tap(() => this.destinationsFacade.invalidate()));
  }

  public edit(id: string, data: SetStorageType): Observable<PartialSuccessResponse | null> {
    return this.service.edit(id, data).pipe(tap(() => this.destinationsFacade.invalidate()));
  }

  public delete(id: string, params: { deleteWithData: boolean; code?: string; redirectUri?: string }): Observable<null> {
    return this.service.deleteV2(id, params).pipe(tap(() => this.destinationsFacade.invalidate()));
  }

  public cancelDeletion(id: string): Observable<null> {
    return this.service.cancelDeletion(id).pipe(tap(() => this.destinationsFacade.invalidate()));
  }
}
